import { Button, Flex, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import SEO from '../components/SEO';
import { useTranslation } from '../i18n/LanguageContext';

export default function NotFoundPage() {

  const navigate = useNavigate();
  const { t } = useTranslation();
  
  return (
    <main>
      <SEO
        title={t("seo.notFound.title")}
        description={t("seo.notFound.description")}
        noindex={true}
      />
      <Flex
          py={3}
          width={"100%"}
          height={"100%"}
          alignItems={"center"}
          justifyContent={"center"}
          overflowY={"auto"}
          flexDirection={"column"}
          gap={3}
        >
          <Text as="h1" color={"text.medium.coral"} fontSize={"16px"}>{t("notFound.title")}</Text>
          <Text
            as="p"
            maxWidth={"300px"}
            textAlign={"justify"}
            >{t("notFound.description")}</Text>
          <Button variant="coralOutline" onClick={() => {
            navigate('/')
          }}>{t("notFound.goBack")}</Button>
      </Flex>
    </main>
  )
}
